import React, { FC } from 'react';

import * as S from './SideNavigation.styles';

export interface CategoryItem {
  label: string;
  key: string;
  icon?: JSX.Element;
  badge?: JSX.Element;
}

interface Category {
  title: string;
  items: CategoryItem[];
}

export interface SideNavigationProps {
  title: string;
  onClick?: (id: string) => void;
  categories: Category[];
  activeKey?: string;
  disabledKeys?: string[];
  className?: string;
}

export const SideNavigation: FC<SideNavigationProps> = ({
  title,
  categories,
  className,
  activeKey,
  disabledKeys,
  onClick,
}) => {
  return (
    <S.Aside className={className} data-testid="side-navigation">
      <S.Title>{title}</S.Title>
      <S.Categories>
        {categories.map(c => (
          <S.Group key={c.title}>
            <S.CategoryTitle>{c.title}</S.CategoryTitle>
            <S.Items>
              {c.items.map(c => (
                <S.Item
                  key={c.key}
                  onClick={onClick && (() => onClick(c.key))}
                  data-testid="side-navigation-item"
                >
                  <S.StyledDropdownListItem
                    label={c.label}
                    leadingIcon={c.icon}
                    badge={c.badge}
                    isActive={activeKey === c.key}
                    isFocused={false}
                    isDisabled={disabledKeys && disabledKeys.includes(c.key)}
                    data-testid={undefined}
                    role={undefined}
                  />
                </S.Item>
              ))}
            </S.Items>
          </S.Group>
        ))}
      </S.Categories>
    </S.Aside>
  );
};
